export const LOGO_THEME = Object.freeze({
  DARK: "dark",
  WHITE: "white",
});
